<div [@routeAnimations]="getRouteAnimationData()" class="font-Satoshi preserve-3d w-full h-full">
    <router-outlet></router-outlet>
</div>
<app-logout/>
<app-tour/>
